export default "__VITE_ASSET__CLFu3pzI__"